import likeInContest from "../../assests/likeInContest.svg";
import positionOne from "../../assests/winner/positionOne.svg";
import positionTwo from "../../assests/winner/positionTwo.svg";
import positionThree from "../../assests/winner/positionThree.svg";
import { useState } from "react";
import ProfilePopup from "../Profile/ProfilePopup";

export default function WinnerDisplayFrame({ data }) {
  const [showPreview, setShowPreview] = useState(false);
  return (
    <>
      <div
        className="w-[100%] bg-[#202020]"
        onClick={() => setShowPreview(true)}
      >
        <div className="w-[100%] relative">
          <img
            src={data?.thumbnailUrl}
            alt=""
            className="w-[100%] aspect-square object-cover"
          />
          <div className="absolute w-[100%] h-[100%] p-[12px] top-0 left-0 flex flex-col justify-between text-smallest top-and-bottom-gradient">
            <div>
              {data?.position == 1 && <img src={positionOne} />}
              {data?.position == 2 && <img src={positionTwo} />}
              {data?.position == 3 && <img src={positionThree} />}
            </div>
            <div className=" flex items-center justify-between">
              <p className="truncate max-w-[80%]">{data?.participantName}</p>

              <div className="flex gap-[5px]">
                <p>{data?.likesCount}</p>
                <img src={likeInContest} alt="" />
              </div>
            </div>
          </div>
        </div>
        {data?.comment && (
          <div className="p-[12px] ">
            <p className="text-regular-callout text-[#CDCDCD]">
              {data?.comment}
            </p>
          </div>
        )}
      </div>
      {showPreview && (
        <ProfilePopup
          setShowPreview={setShowPreview}
          singleFileDetails={data}
          type="winner"
        />
      )}
    </>
  );
}
